import React from 'react';
import Form from 'react-bootstrap/esm/Form';
import { useDispatch, useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../../redux/configureStore';
import { setFareOption } from '../../../../../../../../redux/fetchActions/legadoPage/outstandingDebitsApp';
import Wrapper from '../../../../../../../../shared/components/Wrapper';

function SetFare() {
  const dispatch = useDispatch();
  const outstandigDebitsFilterState = useSelector(
    (reducer: IReducer) => reducer.outstandigDebitsFilter
  );

  function setFare(event: React.FormEvent<any>) {
    const { value } = event.currentTarget;
    dispatch(setFareOption(value));
  }

  return (
    <Wrapper.Default flexDirection="row" isActive>
      <span>Tarifa:</span>
      <Form.Control
        as="select"
        style={{ width: '10.5rem', margin: '0 0.5rem 0 0.25rem' }}
        value={outstandigDebitsFilterState.fare}
        onChange={(event) => setFare(event)}>
        <option key={0} value={0}>
          {1} - Todas
        </option>
        <option key={1} value={1}>
          {2} - Mensalidade
        </option>
        <option key={2} value={2}>
          {3} - Boletos Vencidos
        </option>
        <option key={3} value={3}>
          {4} - Abertura de Conta - Pessoa Física
        </option>
        <option key={4} value={4}>
          {5} - Abertura de Conta - Pessoa Jurídica
        </option>
      </Form.Control>
    </Wrapper.Default>
  );
}

export default SetFare;
